import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { COMPETITION_URL } from 'app/@common/constants'
import { localizedRoom } from 'app/@utils/catalog'


export default function SelectRooms({...props}) {

    const myProps = {
        urlAjax: COMPETITION_URL.ROOMS,
        placeholder: i18n.t('common:filters.allRooms'),
        // i18n: opciones de room normalizado (value=id_room) por idioma; raw_room (children, value string) intactos
        formatOptionLabel: opt => typeof opt?.value === 'number'
            ? localizedRoom({ id_room: opt.value, name: opt.label })
            : opt?.label,
        isClearable: true,
        isMulti: true,
        icon: { icon: 'bed' },
        styles: {
            option: (styles, { data }) => {
                return {
                    ...styles,
                    backgroundColor: !data.isMain ? undefined : '#E3E8F2',
                    color: !data.isMain ? undefined : '#808080',
                }
            },
            menuPortal: (base) => ({ ...base, zIndex: 2000 }),
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}